import React, { useEffect, useContext } from "react";
import { Loader } from 'pixi.js'
import { useHistory } from "react-router-dom";
import { AnimatedSprite, Container, withFilters } from '@inlet/react-pixi'
import { GlowFilter } from 'pixi-filters';
import { ease } from 'pixi-ease'

import HomeContext from '../../../context/home-context';
import { feedMonster } from '../../../actions/monster-actions';

import { HowlerUtils } from '../../../utils/helpers/island/SoundHelper'
import { getStudentNumberFromSession } from '../../../utils/helpers/others/SessionHelper'

const Filters = withFilters(Container, {
    glow: GlowFilter,
});

let walkingTextures = []; // meed to declare here
let standByTextures = [];
let standBySadTextures = [];
let jumpingTextures = [];
let reverseWalkingTextures = [];
let eatingTextures = [];
let messageTextures = [];
let drumstickTextures = []; // meed to declare here
let berryTextures = [];

const MonsterContainer = ({ _openMessageBox, _notiOpen }) => {
    const history = useHistory();
    const { homeContext, dispatch } = useContext(HomeContext);
    const loader = Loader.shared; // PixiJS exposes a premade instance for you to use.
    const [filter, setFilter] = React.useState(0);
    const eatingId = React.useRef();
    const foodId = React.useRef();

    for (let i = 0; i <= 45;) {
        if (i > 9)
            drumstickTextures.push(loader.resources["./assets/images/components/island/spritesheets/foods/drumstick.json"].textures[`Drumstick 2_000${i}.png`])
        else
            drumstickTextures.push(loader.resources["./assets/images/components/island/spritesheets/foods/drumstick.json"].textures[`Drumstick 2_0000${i}.png`])

        i += 3;
    }
    for (let i = 0; i <= 45;) {
        if (i > 9)
            berryTextures.push(loader.resources["./assets/images/components/island/spritesheets/foods/berry.json"].textures[`Berries 2_000${i}.png`])
        else
            berryTextures.push(loader.resources["./assets/images/components/island/spritesheets/foods/berry.json"].textures[`Berries 2_0000${i}.png`])

        i += 3;
    }

    if (homeContext.monsterMenu.monsterLvl > 0) {
        for (let i = 0; i < 13; i++) {
            messageTextures.push(loader.resources["./assets/images/components/island/spritesheets/others/messages.json"].textures[`s${i}.png`])
        }
        switch (homeContext.monsterMenu.cluster) {
            case 'HSS':
                for (let i = 1; i <= 16; i++) {
                    eatingTextures.push(loader.resources["./assets/images/components/island/spritesheets/dinosaurs/hssDinosaur/hss_eating.json"].textures[`HSS_eating_${i}.png`])
                }
                for (let i = 0; i <= 48;) {

                    if (i >= 10) {
                        walkingTextures.push(loader.resources["./assets/images/components/island/spritesheets/dinosaurs/hssDinosaur/hss_walking.json"].textures[`HSS_walking_000${i}.png`])
                    }
                    else {
                        walkingTextures.push(loader.resources["./assets/images/components/island/spritesheets/dinosaurs/hssDinosaur/hss_walking.json"].textures[`HSS_walking_0000${i}.png`])
                    }

                    i += 3;
                }
                for (let i = 0; i <= 39;) {

                    if (i >= 10) {
                        standByTextures.push(loader.resources["./assets/images/components/island/spritesheets/dinosaurs/hssDinosaur/hss_standby.json"].textures[`HSS_stand by_000${i}.png`])
                    }
                    else {
                        standByTextures.push(loader.resources["./assets/images/components/island/spritesheets/dinosaurs/hssDinosaur/hss_standby.json"].textures[`HSS_stand by_0000${i}.png`])
                    }

                    i += 3;
                }
                for (let i = 0; i <= 48;) {

                    if (i >= 10) {
                        reverseWalkingTextures.push(loader.resources["./assets/images/components/island/spritesheets/dinosaurs/hssDinosaur/hss_reverse_walking.json"].textures[`HSS_walking_000${i}.png`])
                    }
                    else {
                        reverseWalkingTextures.push(loader.resources["./assets/images/components/island/spritesheets/dinosaurs/hssDinosaur/hss_reverse_walking.json"].textures[`HSS_walking_0000${i}.png`])
                    }

                    i += 3;
                }
                for (let i = 3; i <= 60;) {

                    if (i >= 10) {
                        jumpingTextures.push(loader.resources["./assets/images/components/island/spritesheets/dinosaurs/hssDinosaur/hss_jumping.json"].textures[`HSS_jumping up down_000${i}.png`])
                    }
                    else {
                        jumpingTextures.push(loader.resources["./assets/images/components/island/spritesheets/dinosaurs/hssDinosaur/hss_jumping.json"].textures[`HSS_jumping up down_0000${i}.png`])
                    }

                    i += 3;
                }
                for (let i = 24; i <= 96;) {
                    standBySadTextures.push(loader.resources["./assets/images/components/island/spritesheets/dinosaurs/hssDinosaur/hss_sad.json"].textures[`HSS_sad_000${i}.png`])
                    i += 4;
                }
                break;
            case 'DSB':
                for (let i = 3; i <= 60;) {

                    if (i > 9)
                        eatingTextures.push(loader.resources["./assets/images/components/island/spritesheets/dinosaurs/dsbDinosaur/dsb_eating.json"].textures[`DSB_sketch_anim eat_000${i}.png`])

                    else
                        eatingTextures.push(loader.resources["./assets/images/components/island/spritesheets/dinosaurs/dsbDinosaur/dsb_eating.json"].textures[`DSB_sketch_anim eat_0000${i}.png`])

                    i += 3;
                }
                for (let i = 3; i <= 60;) {
                    if (i > 9)
                        standBySadTextures.push(loader.resources["./assets/images/components/island/spritesheets/dinosaurs/dsbDinosaur/dsb_sad.json"].textures[`DSB_sketch_anim standby sad_000${i}.png`])
                    else
                        standBySadTextures.push(loader.resources["./assets/images/components/island/spritesheets/dinosaurs/dsbDinosaur/dsb_sad.json"].textures[`DSB_sketch_anim standby sad_0000${i}.png`])
                    i += 3;
                }
                for (let i = 1; i <= 39;) {
                    if (i > 9)
                        jumpingTextures.push(loader.resources["./assets/images/components/island/spritesheets/dinosaurs/dsbDinosaur/dsb_jumping.json"].textures[`DSB_sketch_anim jump_000${i}.png`])
                    else
                        jumpingTextures.push(loader.resources["./assets/images/components/island/spritesheets/dinosaurs/dsbDinosaur/dsb_jumping.json"].textures[`DSB_sketch_anim jump_0000${i}.png`])
                    i += 2;
                }
                for (let i = 1; i <= 39;) {
                    if (i > 9)
                        walkingTextures.push(loader.resources["./assets/images/components/island/spritesheets/dinosaurs/dsbDinosaur/dsb_walking.json"].textures[`DSB_sketch_anim walk_000${i}.png`])
                    else
                        walkingTextures.push(loader.resources["./assets/images/components/island/spritesheets/dinosaurs/dsbDinosaur/dsb_walking.json"].textures[`DSB_sketch_anim walk_0000${i}.png`])
                    i += 2;
                }
                for (let i = 1; i <= 39;) {
                    if (i > 9)
                        reverseWalkingTextures.push(loader.resources["./assets/images/components/island/spritesheets/dinosaurs/dsbDinosaur/dsb_reverse_walking.json"].textures[`DSB_sketch_anim walk_000${i}.png`])
                    else
                        reverseWalkingTextures.push(loader.resources["./assets/images/components/island/spritesheets/dinosaurs/dsbDinosaur/dsb_reverse_walking.json"].textures[`DSB_sketch_anim walk_0000${i}.png`])
                    i += 2;
                }
                for (let i = 3; i <= 60;) {
                    if (i > 9)
                        standByTextures.push(loader.resources["./assets/images/components/island/spritesheets/dinosaurs/dsbDinosaur/dsb_standby.json"].textures[`DSB_sketch_anim standby_000${i}.png`])
                    else
                        standByTextures.push(loader.resources["./assets/images/components/island/spritesheets/dinosaurs/dsbDinosaur/dsb_standby.json"].textures[`DSB_sketch_anim standby_0000${i}.png`])
                    i += 3;
                }
                break;
            case 'ICT':
                for (let i = 14; i <= 71;) {
                    eatingTextures.push(loader.resources["./assets/images/components/island/spritesheets/dinosaurs/ictDinosaur/ict_eating.json"].textures[`ICT_char_eat_000${i}.png`])
                    i += 3;
                }
                for (let i = 0; i <= 38;) {
                    if (i >= 10) {
                        walkingTextures.push(loader.resources["./assets/images/components/island/spritesheets/dinosaurs/ictDinosaur/ict_walking.json"].textures[`ICT_char_walk_000${i}.png`])
                    }
                    else {
                        walkingTextures.push(loader.resources["./assets/images/components/island/spritesheets/dinosaurs/ictDinosaur/ict_walking.json"].textures[`ICT_char_walk_0000${i}.png`])
                    }
                    i += 2;
                }
                for (let i = 14; i <= 71;) {
                    standByTextures.push(loader.resources["./assets/images/components/island/spritesheets/dinosaurs/ictDinosaur/ict_standby.json"].textures[`ICT_char_standby_000${i}.png`])
                    i += 3;
                }
                for (let i = 0; i <= 38;) {

                    if (i >= 10) {
                        reverseWalkingTextures.push(loader.resources["./assets/images/components/island/spritesheets/dinosaurs/ictDinosaur/ict_reverse_walking.json"].textures[`ICT_char_walk_000${i}.png`])
                    }
                    else {
                        reverseWalkingTextures.push(loader.resources["./assets/images/components/island/spritesheets/dinosaurs/ictDinosaur/ict_reverse_walking.json"].textures[`ICT_char_walk_0000${i}.png`])
                    }

                    i += 2;
                }
                for (let i = 2; i <= 40;) {

                    if (i >= 10) {
                        jumpingTextures.push(loader.resources["./assets/images/components/island/spritesheets/dinosaurs/ictDinosaur/ict_jumping.json"].textures[`ICT_char_jump_000${i}.png`])
                    }
                    else {
                        jumpingTextures.push(loader.resources["./assets/images/components/island/spritesheets/dinosaurs/ictDinosaur/ict_jumping.json"].textures[`ICT_char_jump_0000${i}.png`])
                    }

                    i += 2;
                }
                for (let i = 14; i <= 71;) {
                    standBySadTextures.push(loader.resources["./assets/images/components/island/spritesheets/dinosaurs/ictDinosaur/ict_sad.json"].textures[`ICT_char_standby_sad_000${i}.png`])
                    i += 3;
                }
                break;
            case 'CEFT':
                for (let i = 14; i <= 71;) {
                    eatingTextures.push(loader.resources["./assets/images/components/island/spritesheets/dinosaurs/ceftDinosaur/ceft_eating.json"].textures[`CE&FS_green_eat_000${i}.png`])
                    i += 3;
                }
                for (let i = 0; i <= 38;) {
                    if (i >= 10) {
                        walkingTextures.push(loader.resources["./assets/images/components/island/spritesheets/dinosaurs/ceftDinosaur/ceft_walking.json"].textures[`CE&FS_green_walk_000${i}.png`])
                    }
                    else {
                        walkingTextures.push(loader.resources["./assets/images/components/island/spritesheets/dinosaurs/ceftDinosaur/ceft_walking.json"].textures[`CE&FS_green_walk_0000${i}.png`])
                    }
                    i += 2;
                }
                for (let i = 0; i <= 57;) {
                    if (i >= 10) {
                        standByTextures.push(loader.resources["./assets/images/components/island/spritesheets/dinosaurs/ceftDinosaur/ceft_standby.json"].textures[`CE&FS_green_standby_000${i}.png`])
                    }
                    else {
                        standByTextures.push(loader.resources["./assets/images/components/island/spritesheets/dinosaurs/ceftDinosaur/ceft_standby.json"].textures[`CE&FS_green_standby_0000${i}.png`])
                    }
                    i += 3;
                }
                for (let i = 0; i <= 38;) {
                    if (i >= 10) {
                        reverseWalkingTextures.push(loader.resources["./assets/images/components/island/spritesheets/dinosaurs/ceftDinosaur/ceft_reverse_walking.json"].textures[`CE&FS_green_walk_000${i}.png`])
                    }
                    else {
                        reverseWalkingTextures.push(loader.resources["./assets/images/components/island/spritesheets/dinosaurs/ceftDinosaur/ceft_reverse_walking.json"].textures[`CE&FS_green_walk_0000${i}.png`])
                    }
                    i += 2;
                }
                for (let i = 1; i <= 39;) {
                    if (i >= 10) {
                        jumpingTextures.push(loader.resources["./assets/images/components/island/spritesheets/dinosaurs/ceftDinosaur/ceft_jumping.json"].textures[`CE&FS_green_jump_000${i}.png`])
                    }
                    else {
                        jumpingTextures.push(loader.resources["./assets/images/components/island/spritesheets/dinosaurs/ceftDinosaur/ceft_jumping.json"].textures[`CE&FS_green_jump_0000${i}.png`])
                    }
                    i += 2;
                }
                for (let i = 9; i <= 66;) {
                    if (i >= 10) {
                        standBySadTextures.push(loader.resources["./assets/images/components/island/spritesheets/dinosaurs/ceftDinosaur/ceft_sad.json"].textures[`CE&FS_green_standby_sad_000${i}.png`])
                    }
                    else {
                        standBySadTextures.push(loader.resources["./assets/images/components/island/spritesheets/dinosaurs/ceftDinosaur/ceft_sad.json"].textures[`CE&FS_green_standby_sad_0000${i}.png`])
                    }
                    i += 3;
                }
                break;
            case 'ENG':
                for (let i = 3; i <= 60;) {

                    if (i > 9)
                        eatingTextures.push(loader.resources["./assets/images/components/island/spritesheets/dinosaurs/engDinosaur/eng_eating.json"].textures[`Engine_blue_3_eat_000${i}.png`])

                    else
                        eatingTextures.push(loader.resources["./assets/images/components/island/spritesheets/dinosaurs/engDinosaur/eng_eating.json"].textures[`Engine_blue_3_eat_0000${i}.png`])

                    i += 3;
                }
                for (let i = 10; i <= 67;) {
                    standBySadTextures.push(loader.resources["./assets/images/components/island/spritesheets/dinosaurs/engDinosaur/eng_sad.json"].textures[`Engine_blue_reverse_standby_sad_000${i}.png`])
                    i += 3;
                }
                for (let i = 1; i <= 39;) {
                    if (i > 9)
                        jumpingTextures.push(loader.resources["./assets/images/components/island/spritesheets/dinosaurs/engDinosaur/eng_jumping.json"].textures[`Engine_blue_3_jump_000${i}.png`])
                    else
                        jumpingTextures.push(loader.resources["./assets/images/components/island/spritesheets/dinosaurs/engDinosaur/eng_jumping.json"].textures[`Engine_blue_3_jump_0000${i}.png`])
                    i += 2;
                }
                for (let i = 1; i <= 39;) {
                    if (i > 9)
                        walkingTextures.push(loader.resources["./assets/images/components/island/spritesheets/dinosaurs/engDinosaur/eng_walking.json"].textures[`Engine_blue_3_walk_000${i}.png`])
                    else
                        walkingTextures.push(loader.resources["./assets/images/components/island/spritesheets/dinosaurs/engDinosaur/eng_walking.json"].textures[`Engine_blue_3_walk_0000${i}.png`])
                    i += 2;
                }
                for (let i = 1; i <= 39;) {
                    if (i > 9)
                        reverseWalkingTextures.push(loader.resources["./assets/images/components/island/spritesheets/dinosaurs/engDinosaur/eng_reverse_walking.json"].textures[`Engine_blue_3_walk_000${i}.png`])
                    else
                        reverseWalkingTextures.push(loader.resources["./assets/images/components/island/spritesheets/dinosaurs/engDinosaur/eng_reverse_walking.json"].textures[`Engine_blue_3_walk_0000${i}.png`])
                    i += 2;
                }
                for (let i = 3; i <= 60;) {
                    if (i > 9)
                        standByTextures.push(loader.resources["./assets/images/components/island/spritesheets/dinosaurs/engDinosaur/eng_standby.json"].textures[`Engine_blue_3_standby_000${i}.png`])
                    else
                        standByTextures.push(loader.resources["./assets/images/components/island/spritesheets/dinosaurs/engDinosaur/eng_standby.json"].textures[`Engine_blue_3_standby_0000${i}.png`])
                    i += 3;
                }
                break;
        }
    }

    useEffect(() => {
        loadFoodEvents();
    }, []);

    const loadFoodEvents = () => {
        if (foodId.current !== null && foodId.current !== undefined) {
            foodId.current.x = foodId.current.y = 300;
            foodId.current
                .on('pointerdown', onDragStart)
                .on('pointerup', onDragEnd)
                .on('pointerupoutside', onDragEnd)
                .on('pointermove', onDragMove);
        }
    }

    function onDragStart(event) {
        this.data = event.data;
        this.alpha = 0.5;
        this.dragging = true;
        this.orgX = this.x;
        this.orgY = this.y;
    }

    function onDragEnd() {
        this.alpha = 1;
        this.dragging = false;

        // set the interaction data to null       
        if (this.x >= 400 && this.x < 500
            && this.y >= 150 && this.y < 250) {
            if (!homeContext.monsterMenu.isEating) {
                HowlerUtils.playSound('eating');
                homeContext.monsterMenu.isEating = true;
                dispatch({ type: 'SET_MONSTER_MENU', monsterMenu: homeContext.monsterMenu });

                if (eatingId.current !== null && eatingId.current !== undefined) {
                    eatingId.current.visible = true;
                    const example1 = ease.add(eatingId.current, { position: { x: 502, y: 202 } }, { reverse: true, duration: 1000 })
                    example1.once('complete', () => {

                        if (eatingId.current !== null && eatingId.current !== undefined) {
                            handleFeedMonster();
                        }
                    })
                }
            }
        }
        else {
            this.x = this.orgX;
            this.y = this.orgY;
        }
        this.data = null;
    }

    function onDragMove() {
        if (this.dragging) {
            const newPosition = this.data.getLocalPosition(this.parent);
            this.x = newPosition.x;
            this.y = newPosition.y;
            if (this.x >= 400 && this.x < 500
                && this.y >= 150 && this.y < 250) {
                //set filter to dinosaur
                setFilter(4);
            }
            else {
                setFilter(0);
            }
        }
    }

    const handleFeedMonster = async () => {
        let response = await feedMonster(getStudentNumberFromSession());
        if (response > 200 || response.status === "Failed") {
            return history.push("/SessionTimeOut")
        }
        if (response.status === "Success") {
            if (eatingId.current !== null && eatingId.current !== undefined) {
                homeContext.dailyChestClaim.foodCount -= 1;
                dispatch({ type: 'SET_DAILYCHESTCLAIM', dailyChestClaim: homeContext.dailyChestClaim });

                homeContext.monsterMenu.monsterLvl = response.data.monsterLvl;
                homeContext.monsterMenu.moodMeter = response.data.moodMeter;
                homeContext.monsterMenu.feedCount += 1;
                homeContext.monsterMenu.isEating = false;
                if (foodId.current !== null && foodId.current !== undefined) {
                    foodId.current.x = foodId.current.y = 300;
                }

                if (response.data.isNewLevel)
                    _notiOpen();

                switch (parseInt(response.data.monsterLvl)) {
                    case 2:
                        homeContext.monsterMenu.monsterSize = { x: 0.4, y: 0.4 };
                        break;
                    case 3:
                        homeContext.monsterMenu.monsterSize = { x: 0.5, y: 0.5 };
                        break;
                    case 4:
                        homeContext.monsterMenu.monsterSize = { x: 0.6, y: 0.6 };
                        break;
                }

                dispatch({ type: 'SET_MONSTER_MENU', monsterMenu: homeContext.monsterMenu });

                eatingId.current.visible = false;
                setFilter(0);

                HowlerUtils.stopSound('eating');
            }
        }
    }

    return (
        <>
            <Filters scale={1} glow={{ distance: 100, outerStrength: filter, innerStrength: filter / 4, quality: 0, color: '0xf5f5f5' }}>
                {
                    homeContext.monsterMenu.moodMeter >= 50 ?
                        homeContext.monsterMenu.moodMeter >= 75 ?
                            <AnimatedSprite
                                textures={jumpingTextures} visible={!homeContext.monsterMenu.isEating}
                                scale={homeContext.monsterMenu.monsterSize} isPlaying={!homeContext.monsterMenu.isEating}
                                animationSpeed={0.15} x={500} y={200}
                                buttonMode={true} interactive={true}
                                pointerdown={() => {
                                    HowlerUtils.playSound('speaking');
                                    _openMessageBox();
                                }}
                            />
                            :
                            <AnimatedSprite
                                textures={standByTextures} visible={!homeContext.monsterMenu.isEating}
                                scale={homeContext.monsterMenu.monsterSize} isPlaying={!homeContext.monsterMenu.isEating}
                                animationSpeed={0.15} x={500} y={200}
                                buttonMode={true} interactive={true}
                                pointerdown={() => {
                                    HowlerUtils.playSound('speaking');
                                    _openMessageBox();
                                }}
                            />
                        :
                        <AnimatedSprite
                            textures={standBySadTextures} visible={!homeContext.monsterMenu.isEating}
                            scale={homeContext.monsterMenu.monsterSize} isPlaying={!homeContext.monsterMenu.isEating}
                            animationSpeed={0.15} x={500} y={200}
                            buttonMode={true} interactive={true}
                            pointerdown={() => {
                                HowlerUtils.playSound('speaking');
                                _openMessageBox();
                            }}
                        />
                }
            </Filters>
            <AnimatedSprite
                textures={messageTextures} visible={!homeContext.monsterMenu.isEating}
                scale={{ x: 0.3, y: 0.3 }} isPlaying={!homeContext.monsterMenu.isEating}
                animationSpeed={0.05} x={470} y={80}
                buttonMode={true} interactive={true}
                pointerdown={() => {
                    _openMessageBox();
                }}
            />
            <AnimatedSprite
                ref={eatingId}
                textures={eatingTextures} visible={false}
                scale={homeContext.monsterMenu.monsterSize} isPlaying={homeContext.monsterMenu.isEating}
                animationSpeed={0.15} x={500} y={200}
            />
            {
                homeContext.dailyChestClaim.foodCount > 0 ?
                    <AnimatedSprite ref={foodId} animationSpeed={0.09} isPlaying={true}
                        initialFrame={0}
                        visible={!homeContext.monsterMenu.isEating}
                        scale={{ x: 0.2, y: 0.2 }}
                        textures={homeContext.monsterMenu.cluster === "CEFT" ||
                            homeContext.monsterMenu.cluster === "ENG" ? berryTextures : drumstickTextures}
                        interactive={true} buttonMode={true}
                    />
                    : <></>
            }
        </>
    );
};

export { MonsterContainer as default }